<div class="container my-5">
  <div class="container my-5 text-center " style="width: 75%">
    <h3  class="display-5 fw-light" style="color: var(--secondary-color);">Responsabilidades en <span class="fw-bold"> <br>Seguridad y Salud en el Trabajo </span></h3>
  </div>
  <img src="/assets/img/enterprise/decretoNormativa.svg" alt="decretoNormativa">
</div>
